import React from "react";
import BannerImage from "./BannerImage";
import LeftImgRightText from "./LeftImgRightText";
import RightImgLeftText from "./RightImgLeftText";
import "../App.css";

const SpendGuard = () => {
  document.title = "SpendGuard";

  return (
    <div className="ui">
      <BannerImage
        title={"Manage to excel"}
        image={require("../assets/img/sg/gg1.jpg")}
      />

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/sg/p1.png")}
          text={"SpendGuard"}
          obj={{
            title: "Calendar View Expenses",
            desc: "Overview of monthly expenses in one glance",
            dl:
              "Toggle on each date to see how much you spend for each day and which item.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/sg/p2.png")}
          text={"SpendGuard"}
          obj={{
            title: "Multiple Categories",
            desc: "A lot of categories to choose from.",
            dl:
              "Manage your expenses based on category so that you will be able to understand your spending habits in a clearer manner.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/sg/p4.png")}
          text={"SpendGuard"}
          obj={{
            title: "Interactive and Intuitive",
            desc: "Add your own daily expenses",
            dl:
              "Whatever you spend, note it down and analyse it after a month or so.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/sg/p5.png")}
          text={"SpendGuard"}
          obj={{
            title: "Visualise your expenses",
            desc: "Chart speaks of a thousand words",
            dl:
              "Let interactive charts paint you a better picture of your exact spending habits.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/sg/p8.png")}
          text={"SpendGuard"}
          obj={{
            title: "More theme",
            desc: "Don't like dark mode? Check here to change",
            dl:
              "Head to the settings by sliding the left menu and change the theme to dark or light mode based on your own preference.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/spendguard/id1482284888",
            android:
              "https://play.google.com/store/apps/details?id=io.devjo.expense",
          }}
        />
      </div>
    </div>
  );
};

export default SpendGuard;
